module.exports = __webpack_public_path__ + "src/assets/games/42/127.jpg";